import dateformat from 'dateformat'

export const UNKNOWN_SHOWER_STATUS_TEXT = 'Shower, sprinkle, or just a list?'
export const NOT_HAVING_SHOWER_TEXT = 'No shower planned. This is just for me!'
export const TBD_DATE_SHOWER_TEXT = 'Celebrating sometime soon!'

export const getCopy = (info) => {
  if (info.havingShower === null || info.havingShower === undefined) {
    return <span>{UNKNOWN_SHOWER_STATUS_TEXT}</span>
  }
  if (info.havingShower === false) {
    return <span>{NOT_HAVING_SHOWER_TEXT}</span>
  }
  if (info.showers.every((s) => s.date === null)) {
    return <span>{TBD_DATE_SHOWER_TEXT}</span>
  }
  return upcomingShowerText(info.showers)
}

export const upcomingShowerText = (showers) => {
  const showerDateStrings = showers
    .filter((s) => s.date)
    .map((s) => formatDateString(s.date))
  return (
    <span>
      Celebrating
      <br />
      {` ${formatHumanReadableList(showerDateStrings)}.`}
    </span>
  )
}

export const formatDateString = (date) => {
  return dateformat(date, 'UTC:mmmm dS')
}

export const formatHumanReadableList = (list) => {
  if (list.length < 2) {
    return list[0]
  }

  const copiedList = [...list]
  const lastItem = copiedList.pop()
  const formattedList = copiedList.join(', ')
  return `${formattedList} and ${lastItem}`
}
